import * as React from 'react';
import { CollapsedText } from '../CollapsedText';
import { Section } from '../Section';
import { IDescriptionProps } from './types';

export const DescriptionMobile: React.FC<IDescriptionProps> = ({ text, html }) => {
  return (
    <Section title="Описание">
      <CollapsedText text={text} html={html} lineHeight={24} lineCount={6} expandButtonText="Посмотреть всё" />
    </Section>
  );
};
